import classNames from 'classnames';
import { FunctionComponent, TextareaHTMLAttributes } from 'react';
import formItemStyles from 'styles/BFormItem.module.css';

export type BTextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

const BTextArea: FunctionComponent<BTextAreaProps> = ({
  className,
  ...attrs
}) => {
  return (
    <textarea
      className={classNames(formItemStyles['b-form-item'], className)}
      {...attrs}
    />
  );
};

export default BTextArea;
